/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { Title, SectionTitle, SectionContent, FinePrint, PrivacyLinks, PrivacyWrapper } from '../util'
import { push } from 'connected-react-router'
import { Button } from '../../util'
import { ContactSupportCopy } from '../util'
import { selectAppConfig } from 'services/bootup/selectors'

const mapStateToProps = (state) => ({
  appConfig: selectAppConfig(state),
})

const mapDispatchToActions = {
  navigate: push,
}

function DeclineConsentsPage (props) {
  const { appConfig, isMobile, navigate } = props
  const deleteLink = isMobile ? '/mobile/account/delete' : '/account/delete'

  return (
    <PrivacyWrapper>
      <Title>
        <FormattedMessage id='privacy_center.decline.title' defaultMessage="Are You Sure?" />
      </Title>

      <SectionTitle>
        <FormattedMessage id='privacy_center.before_you_remove.title' defaultMessage="Before You Remove Consents" />
      </SectionTitle>

      <SectionContent>
        <FormattedHTMLMessage
          id='privacy_center.before_you_remove.content'
          defaultMessage={`
            <p><strong>Removing consent will require you to immediately and permanently delete your account.</strong></p>
            <p>You will permanently lose access to the data associated with this profile, including workouts, notes, sleep sessions, feed posts, and any photos or videos attached to posts.</p>
            <p><strong>Once completed, this action cannot be undone.</strong></p>
          `}
        />
      </SectionContent>

      <SectionTitle>
        <FormattedMessage id='privacy_center.request_your_data.title' defaultMessage="Request Your Data" />
      </SectionTitle>

      <SectionContent>
        <FormattedMessage
          id='privacy_center.request_your_data.content'
          defaultMessage="View the following links if you have questions about how to save your data. Your data cannot be accessed after you delete your account" />
      </SectionContent>

      <PrivacyLinks
        exportData={true}
        contactSupport={!appConfig.isChina}
        isMobile={isMobile}
        screenName='consent_decline'
      />

      {appConfig.isChina ?
        <SectionContent>
          <ContactSupportCopy />
        </SectionContent>
      : null}

      <FinePrint>
        <FormattedMessage
          id='privacy_center.consent_decline.fine_print'
          defaultMessage='Your consent will not be fully removed until you finish deleting your account on the following screens.'
        />
      </FinePrint>

      <div style={ { textAlign: 'center' } }>
        <Button
          size='xlarge'
          type='danger'
          onClick={ () => {
            if (isMobile) {
              window.location.href = deleteLink
            } else {
              navigate({ pathname: deleteLink })
            }
          } }
        >
          <FormattedMessage
            id='privacy_center.consent_decline.im_sure'
            defaultMessage="Yes, I'm Sure"
          />
        </Button>
      </div>
    </PrivacyWrapper>
  )
}

DeclineConsentsPage.propTypes = {
  appConfig: PropTypes.object,
  isMobile: PropTypes.bool,
  navigate: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToActions)(DeclineConsentsPage)
